import { render } from "./ArticleCountDown.vue?vue&type=template&id=23c81131&scoped=true&ts=true"
import script from "./ArticleCountDown.vue?vue&type=script&lang=ts"
export * from "./ArticleCountDown.vue?vue&type=script&lang=ts"

import "./ArticleCountDown.vue?vue&type=style&index=0&id=23c81131&lang=scss&scoped=true"

import exportComponent from "/Users/macbook/Documents/work_code/global/events_gevents.37games.com/src/resource/guidetro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c81131"]])

export default __exports__